import React, { Fragment } from 'react';
import { showNotification } from './../../../utils';
import {
    getCanvasFrontDataUrl,
    getCanvasBackDataUrl,
    getCanvasValues,
    isEmpty,
} from './../CanvasActions';
import FormP1T1 from './FormP1T1';
import FormP1T2 from './FormP1T2';
import FormP1T3 from './FormP1T3';
import FormP1T4 from './FormP1T4';
import FormP1T5 from './FormP1T5';
import FormP1T6 from './FormP1T6';
import FormP1T7 from './FormP1T7';
import FormP1T8 from './FormP1T8';
import FormP1T9 from './FormP1T9';
import FormP1T10 from './FormP1T10';
import FormP1T11 from './FormP1T11';
import FormP1T12 from './FormP1T12';
import FormP1T13 from './FormP1T13';
import FormP1T14 from './FormP1T14';
import FormP1T15 from './FormP1T15';
import FormP1T16 from './FormP1T16';
import FormP1T17 from './FormP1T17';
import FormP1T18 from './FormP1T18';
import FormP2T1 from './FormP2T1';
import FormP2T2 from './FormP2T2';
import FormP2T3 from './FormP2T3';
import FormP2T4 from './FormP2T4';
import FormP3T1 from './FormP3T1';
import FormP3T2 from './FormP3T2';
import FormP3T3 from './FormP3T3';
import FormP3T4 from './FormP3T4';
import FormP3T5 from './FormP3T5';
import FormP3T6 from './FormP3T6';
import FormP4T1 from './FormP4T1';
import FormP4T3 from './FormP4T3';
import FormP9 from './FormP9';
import FormP9T11 from './FormP9T11';
import FormP9T12 from './FormP9T12';
import FormP9T13 from './FormP9T13';
import FormP9T14 from './FormP9T14';
import FormP9T15 from './FormP9T15';
import FormP9T16 from './FormP9T16';
import FormP9T17 from './FormP9T17';
import FormP9T18 from './FormP9T18';
import FormP9T19 from './FormP9T19';
import FormP9T20 from './FormP9T20';
import FormP9T21 from './FormP9T21';
import FormP9T22 from './FormP9T22';
import FormP9T23 from './FormP9T23';
import FormP10 from './FormP10';
import FormP10T8 from './FormP10T8';
import FormP10T9 from './FormP10T9';
import FormP10T10 from './FormP10T10';
import FormP11 from './FormP11';
import FormP11T22 from './FormP11T22';
import FormP11T23 from './FormP11T23';
import FormP11T24 from './FormP11T24';
import FormP11T25 from './FormP11T25';
import FormP12 from './FormP12';
import FormP17T1 from './FormP17T1';
import FormP17T2 from './FormP17T2';
import FormP17T3 from './FormP17T3';
import FormP17T4 from './FormP17T4';
import FormP17T5 from './FormP17T5';
import FormP18T1 from './FormP18T1';
import FormP18T2 from './FormP18T2';
import FormP18T3 from './FormP18T3';
import FormP18T4 from './FormP18T4';
import FormP19T1 from './FormP19T1';
import FormP20 from './FormP20';
import FormP20T7 from './FormP20T7';
import FormP20T8 from './FormP20T8';
import FormP20T9 from './FormP20T9';
import FormP21T1 from './FormP21T1';
import FormP21T2 from './FormP21T2';
import FormP22T1 from './FormP22T1';
import FormP22T2 from './FormP22T2';
import FormP22T3 from './FormP22T3';

const Form = React.memo((props) => {
    const validateFieldsP1T1 = () => {
        return false;

        // if (
        //     props.name === '' ||
        //     props.title1 === '' ||
        //     props.department1 === '' ||
        //     props.phone === '' ||
        //     props.address === '' ||
        //     props.city === '' ||
        //     props.state === '' ||
        //     props.zip === '' ||
        //     props.email === '' ||
        //     props.quantity === ''
        // ) {
        //     return false;
        // }
        // return true;
    };

    const validateFieldsP1T2 = () => {
        return false;

        // if (
        //     props.name === '' ||
        //     props.title1 === '' ||
        //     props.phone === '' ||
        //     props.address === '' ||
        //     props.city === '' ||
        //     props.state === '' ||
        //     props.zip === '' ||
        //     props.email === '' ||
        //     props.quantity === ''
        // ) {
        //     return false;
        // }
        // return true;
    };

    const validateFieldsP1T3 = () => {
        return false;

        // if (
        //     props.name === '' ||
        //     props.title1 === '' ||
        //     props.phone === '' ||
        //     props.clinic === '' ||
        //     props.address === '' ||
        //     props.city === '' ||
        //     props.state === '' ||
        //     props.zip === '' ||
        //     props.email === '' ||
        //     props.quantity === ''
        // ) {
        //     return false;
        // }
        // return true;
    };

    const validateFieldsP1T4 = () => {
        return false;

        // if (
        //     props.name === '' ||
        //     props.title1 === '' ||
        //     props.department1 === '' ||
        //     props.address === '' ||
        //     props.city === '' ||
        //     props.state === '' ||
        //     props.zip === '' ||
        //     props.phone === '' ||
        //     props.quantity === ''
        // ) {
        //     return false;
        // }
        // return true;
    };

    const validateFieldsP1T5 = () => {
        return false;

        // if (
        //     props.name === '' ||
        //     props.title1 === '' ||
        //     props.department1 === '' ||
        //     !props.locationNames[0] || props.locationNames[0] === '' ||
        //     !props.locationPhones[0] || props.locationPhones[0] === '' ||
        //     !props.locationAddresses1[0] || props.locationAddresses1[0] === '' ||
        //     !props.locationCities[0] || props.locationCities[0] === '' ||
        //     !props.locationStates[0] || props.locationStates[0] === '' ||
        //     !props.locationZips[0] || props.locationZips[0] === '' ||
        //     props.quantity === ''
        // ) {
        //     return false;
        // }
        // return true;
    };

    const validateFieldsP1T6 = () => {
        return false;

        // if (
        //     props.name === '' ||
        //     props.title1 === '' ||
        //     props.department1 === '' ||
        //     !props.locationNames[0] || props.locationNames[0] === '' ||
        //     !props.locationPhones[0] || props.locationPhones[0] === '' ||
        //     !props.locationAddresses1[0] || props.locationAddresses1[0] === '' ||
        //     !props.locationCities[0] || props.locationCities[0] === '' ||
        //     !props.locationStates[0] || props.locationStates[0] === '' ||
        //     !props.locationZips[0] || props.locationZips[0] === '' ||
        //     props.quantity === ''
        // ) {
        //     return false;
        // }
        // return true;
    };

    const validateFieldsP1T7 = () => {
        return false;

        // if (
        //     props.name === '' ||
        //     props.title1 === '' ||
        //     props.department1 === '' ||
        //     props.phone === '' ||
        //     props.address === '' ||
        //     props.city === '' ||
        //     props.state === '' ||
        //     props.zip === '' ||
        //     props.email === '' ||
        //     props.quantity === ''
        // ) {
        //     return false;
        // }
        // return true;
    };

    const validateFieldsP1T8 = () => {
        if (
            props.name === '' ||
            props.phone === '' ||
            props.address === '' ||
            props.city === '' ||
            props.state === '' ||
            props.zip === '' ||
            props.quantity === ''
        ) {
            return false;
        }
        return true;
    };

    const validateFieldsP1T9 = () => {
        if (
            props.name === '' ||
            props.title1 === '' ||
            props.department1 === '' ||
            props.phone === '' ||
            props.address === '' ||
            props.city === '' ||
            props.state === '' ||
            props.zip === '' ||
            props.stock === '' ||
            props.quantity === ''
        ) {
            return false;
        }
        return true;
    };

    const validateFieldsP1T10 = () => {
        if (props.quantity === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP1T11 = () => {
        if (
            props.name === '' ||
            props.title1 === '' ||
            props.department1 === '' ||
            props.phone === '' ||
            props.address === '' ||
            props.city === '' ||
            props.state === '' ||
            props.zip === '' ||
            props.window === '' ||
            props.quantity === ''
        ) {
            return false;
        }
        return true;
    };

    const validateFieldsP1T12 = () => {
        if (props.quantity === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP1T13 = () => {
        if (
            props.department1 === '' ||
            props.phone === '' ||
            props.address === '' ||
            props.city === '' ||
            props.state === '' ||
            props.zip === '' ||
            props.stock === '' ||
            props.quantity === ''
        ) {
            return false;
        }

        for (let i = 0; i < props.locations; i++) {
            if (
                props.locationNames[i] === '' ||
                props.locationCities[i] === '' ||
                props.locationZips[i] === '' ||
                props.locationPhones[i] === ''
            ) {
                return false;
            }
        }

        return true;
    };

    const validateFieldsP1T14 = () => {
        if (
            props.department1 === '' ||
            props.phone === '' ||
            props.address === '' ||
            props.city === '' ||
            props.state === '' ||
            props.zip === '' ||
            props.quantity === ''
        ) {
            return false;
        }
        return true;
    };

    const validateFieldsP1T16 = () => {
        if (
            props.name === '' ||
            props.title1 === '' ||
            props.phone === '' ||
            props.address === '' ||
            props.city === '' ||
            props.state === '' ||
            props.zip === '' ||
            props.stock === '' ||
            props.quantity === ''
        ) {
            return false;
        }

        for (let i = 0; i < props.locations; i++) {
            if (
                isEmpty(props.locationCities[i]) ||
                isEmpty(props.locationZips[i]) ||
                isEmpty(props.locationPhones[i])
            ) {
                return false;
            }
        }

        return true;
    };

    const validateFieldsP1T17 = () => {
        if (props.quantity === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP1T15 = () => {
        if (
            props.name === '' ||
            props.title1 === '' ||
            props.department1 === '' ||
            props.phone === '' ||
            props.address === '' ||
            props.city === '' ||
            props.state === '' ||
            props.zip === '' ||
            props.quantity === ''
        ) {
            return false;
        }
        return true;
    };

    const validateFieldsP1T18 = () => {
        if (props.quantity === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP2T1 = () => {
        if (
            props.name === '' ||
            props.phone === '' ||
            props.address === '' ||
            props.city === '' ||
            props.state === '' ||
            props.zip === '' ||
            props.quantity === ''
        ) {
            return false;
        }
        return true;
    };

    const validateFieldsP2T2 = () => {
        if (props.quantity === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP2T3 = () => {
        if (
            props.department1 === '' ||
            props.phone === '' ||
            props.address === '' ||
            props.city === '' ||
            props.state === '' ||
            props.zip === '' ||
            props.quantity === ''
        ) {
            return false;
        }
        return true;
    };

    const validateFieldsP2T4 = () => {
        if (props.quantity === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP3T1 = () => {
        if (
            props.name === '' ||
            props.address === '' ||
            props.city === '' ||
            props.state === '' ||
            props.zip === '' ||
            props.quantity === ''
        ) {
            return false;
        }
        return true;
    };

    const validateFieldsP3T2 = () => {
        if (
            props.name === '' ||
            props.address === '' ||
            props.city === '' ||
            props.state === '' ||
            props.zip === '' ||
            props.quantity === ''
        ) {
            return false;
        }
        return true;
    };

    const validateFieldsP3T3 = () => {
        if (
            props.name === '' ||
            props.address === '' ||
            props.city === '' ||
            props.state === '' ||
            props.zip === '' ||
            props.quantity === ''
        ) {
            return false;
        }
        return true;
    };

    const validateFieldsP3T4 = () => {
        if (
            props.department1 === '' ||
            props.address === '' ||
            props.city === '' ||
            props.state === '' ||
            props.zip === '' ||
            props.quantity === ''
        ) {
            return false;
        }
        return true;
    };

    const validateFieldsP3T5 = () => {
        if (
            props.department1 === '' ||
            props.address === '' ||
            props.city === '' ||
            props.state === '' ||
            props.zip === '' ||
            props.quantity === ''
        ) {
            return false;
        }
        return true;
    };

    const validateFieldsP3T6 = () => {
        if (
            props.department1 === '' ||
            props.address === '' ||
            props.city === '' ||
            props.state === '' ||
            props.zip === '' ||
            props.quantity === ''
        ) {
            return false;
        }
        return true;
    };

    const validateFieldsP4T1 = () => {
        if (props.quantity === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP4T3 = () => {
        if (props.quantity === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP9 = () => {
        if (props.quantity === '' || props.suiteRoom === '' || props.firstName === '' || props.lastName === '' || props.email === '') {
            return false;
        }
        if (props.templateCode === 'p9t6' && props.address2 === '') {
            return false;
        }
        if (props.templateCode === 'p9t7' && props.address2 === '') {
            return false;
        }
        if (props.templateCode === 'p9t8' && props.address2 === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP9T9 = () => {
        if (parseInt(props.back) === 1) {
            if (props.quantity === '' || props.firstName === '' || props.lastName === '' || props.email === '') {
                return false;
            }
        } else {
            if (props.quantity === '') {
                return false;
            }
        }
        return true;
    };

    const validateFieldsP9T10 = () => {
        if (props.quantity === '' || props.suiteRoom === '' || props.email === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP9T11 = () => {
        if (props.quantity === '' || props.suiteRoom === '' || props.firstName === '' || props.lastName === '' || props.email === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP9T12 = () => {
        if (props.quantity === '' || props.suiteRoom === '' || props.firstName === '' || props.lastName === '' || props.email === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP9T13 = () => {
        if (props.quantity === '' || props.suiteRoom === '' || props.email === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP9T14 = () => {
        if (props.quantity === '' || props.suiteRoom === '' || props.firstName === '' || props.lastName === '' || props.email === '' || props.address2 === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP9T15 = () => {
        if (props.quantity === '' || props.suiteRoom === '' || props.firstName === '' || props.lastName === '' || props.email === '' || props.address2 === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP9T16 = () => {
        if (props.quantity === '' || props.suiteRoom === '' || props.firstName === '' || props.lastName === '' || props.email === '' || props.address2 === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP9T17 = () => {
        if (props.quantity === '' || props.suiteRoom === '' || props.firstName === '' || props.lastName === '' || props.email === '' || props.address2 === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP9T18 = () => {
        if (props.quantity === '' || props.suiteRoom === '' || props.firstName === '' || props.lastName === '' || props.email === '' || props.address2 === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP9T19 = () => {
        if (props.quantity === '' || props.suiteRoom === '' || props.firstName === '' || props.lastName === '' || props.email === '' || props.address2 === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP9T20 = () => {
        if (props.quantity === '' || props.suiteRoom === '' || props.firstName === '' || props.lastName === '' || props.email === '' || props.address2 === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP9T21 = () => {
        if (props.quantity === '' || props.suiteRoom === '' || props.firstName === '' || props.lastName === '' || props.email === '' || props.address2 === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP9T22 = () => {
        if (props.quantity === '' || props.suiteRoom === '' || props.firstName === '' || props.lastName === '' || props.email === '' || props.address2 === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP9T23 = () => {
        if (props.quantity === '' || props.suiteRoom === '' || props.firstName === '' || props.lastName === '' || props.email === '' || props.address2 === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP10 = () => {
        if (props.quantity === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP10T8 = () => {
        if (props.quantity === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP10T9 = () => {
        if (props.quantity === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP10T10 = () => {
        if (props.quantity === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP11 = () => {
        if (props.quantity === '' || props.suiteRoom === '' || props.address2 === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP11T24 = () => {
        if (props.quantity === '' || props.suiteRoom === '' || props.address2 === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP12 = () => {
        if (props.quantity === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP17 = () => {
        if (props.quantity === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP18 = () => {
        if (props.quantity === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP18T2 = () => {
        if (props.quantity === '' || props.title1 === '' || props.address === '' || props.address2 === '' || props.phone === '') {
            return false;
        }

        for (let i = 0; i < props.prescriptionPadDoctors.length; i++) {
            const doctor = props.prescriptionPadDoctors[i];
            if (doctor.name === '') {
                return false;
            }
        }

        return true;
    };

    const validateFieldsP18T3 = () => {
        if (
            props.department1 === '' ||
            props.phone === '' ||
            props.address === '' ||
            props.city === '' ||
            props.state === '' ||
            props.zip === '' ||
            props.quantity === ''
        ) {
            return false;
        }

        return true;
    };

    const validateFieldsP19 = () => {
        if (parseInt(props.quantity1) === 0 && parseInt(props.quantity2) === 0 && parseInt(props.quantity3) === 0) {
            return false;
        }
        return true;
    };

    const validateFieldsP20 = () => {
        if (props.quantity === '' || props.firstName === '' || props.lastName === '') {
            return false;
        }
        return true;
    };

    const validateFieldsP21T1 = () => {
        if (
            props.department1 === '' ||
            props.address === '' ||
            props.city === '' ||
            props.state === '' ||
            props.zip === '' ||
            props.quantity === ''
        ) {
            return false;
        }
        return true;
    };

    const validateFieldsP21T2 = () => {
        if (
            props.department1 === '' ||
            props.address === '' ||
            props.city === '' ||
            props.state === '' ||
            props.zip === '' ||
            props.quantity === ''
        ) {
            return false;
        }
        return true;
    };

    const validateFieldsP22T1 = () => {
        if (
            props.language === '' ||
            props.clinicId === '' ||
            props.quantity === ''
        ) {
            return false;
        }
        return true;
    };

    const validateFieldsP22T2 = () => {
        if (
            props.language === '' ||
            props.clinicId === '' ||
            props.quantity === ''
        ) {
            return false;
        }
        return true;
    };

    const validateFieldsP22T3 = () => {
        console.log(props.clinicId)
        if (
            props.clinicId === '' ||
            props.quantity === ''
        ) {
            return false;
        }
        return true;
    };

    const continueHandler = (type = 1) => {
        let validToContinue = true;
        if (props.templateCode === 'p1t1' && !validateFieldsP1T1()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t2' && !validateFieldsP1T2()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t3' && !validateFieldsP1T3()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t4' && !validateFieldsP1T4()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t5' && !validateFieldsP1T5()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t6' && !validateFieldsP1T6()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t7' && !validateFieldsP1T7()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t8' && !validateFieldsP1T8()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t9' && !validateFieldsP1T9()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t10' && !validateFieldsP1T10()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t11' && !validateFieldsP1T11()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t12' && !validateFieldsP1T12()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t13' && !validateFieldsP1T13()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t14' && !validateFieldsP1T14()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t16' && !validateFieldsP1T16()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t17' && !validateFieldsP1T17()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t15' && !validateFieldsP1T15()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t18' && !validateFieldsP1T18()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p2t1' && !validateFieldsP2T1()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p2t2' && !validateFieldsP2T2()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p2t3' && !validateFieldsP2T3()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p2t4' && !validateFieldsP2T4()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p3t1' && !validateFieldsP3T1()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p3t2' && !validateFieldsP3T2()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p3t3' && !validateFieldsP3T3()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p3t4' && !validateFieldsP3T4()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p3t5' && !validateFieldsP3T5()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p3t6' && !validateFieldsP3T6()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p4t1' && !validateFieldsP4T1()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p4t3' && !validateFieldsP4T3()) {
            validToContinue = false;
        }
        if (['p9t1', 'p9t2', 'p9t3', 'p9t4', 'p9t5', 'p9t6', 'p9t7', 'p9t8'].includes(props.templateCode) && !validateFieldsP9()) {
            validToContinue = false;
        }
        if (['p9t9'].includes(props.templateCode) && !validateFieldsP9T9()) {
            validToContinue = false;
        }
        if (['p9t10'].includes(props.templateCode) && !validateFieldsP9T10()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p9t11' && !validateFieldsP9T11()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p9t12' && !validateFieldsP9T12()) {
            validToContinue = false;
        }
        if (['p9t13'].includes(props.templateCode) && !validateFieldsP9T13()) {
            validToContinue = false;
        }
        if (['p9t14'].includes(props.templateCode) && !validateFieldsP9T14()) {
            validToContinue = false;
        }
        if (['p9t15'].includes(props.templateCode) && !validateFieldsP9T15()) {
            validToContinue = false;
        }
        if (['p9t16'].includes(props.templateCode) && !validateFieldsP9T16()) {
            validToContinue = false;
        }
        if (['p9t17'].includes(props.templateCode) && !validateFieldsP9T17()) {
            validToContinue = false;
        }
        if (['p9t18'].includes(props.templateCode) && !validateFieldsP9T18()) {
            validToContinue = false;
        }
        if (['p9t19'].includes(props.templateCode) && !validateFieldsP9T19()) {
            validToContinue = false;
        }
        if (['p9t20'].includes(props.templateCode) && !validateFieldsP9T20()) {
            validToContinue = false;
        }
        if (['p9t21'].includes(props.templateCode) && !validateFieldsP9T21()) {
            validToContinue = false;
        }
        if (['p9t22'].includes(props.templateCode) && !validateFieldsP9T22()) {
            validToContinue = false;
        }
        if (['p9t23'].includes(props.templateCode) && !validateFieldsP9T23()) {
            validToContinue = false;
        }
        if (['p10t1', 'p10t2', 'p10t3', 'p10t4', 'p10t5', 'p10t6', 'p10t7'].includes(props.templateCode) && !validateFieldsP10()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p10t8' && !validateFieldsP10T8()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p10t9' && !validateFieldsP10T9()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p10t10' && !validateFieldsP10T10()) {
            validToContinue = false;
        }
        if (['p11t1', 'p11t2', 'p11t3', 'p11t4', 'p11t5', 'p11t6', 'p11t7', 'p11t8', 'p11t9', 'p11t10',
            'p11t11', 'p11t12', 'p11t13', 'p11t14', 'p11t15', 'p11t16', 'p11t17', 'p11t18', 'p11t19', 'p11t20',
            'p11t21', 'p11t22', 'p11t23', 'p11t25'].includes(props.templateCode) && !validateFieldsP11()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p11t24' && !validateFieldsP11T24()) {
            validToContinue = false;
        }
        if (['p12t1', 'p12t2', 'p12t3', 'p12t4', 'p12t5', 'p12t6', 'p12t7', 'p12t8', 'p12t9', 'p12t10'].includes(props.templateCode) && !validateFieldsP12()) {
            validToContinue = false;
        }
        if (['p17t1', 'p17t2', 'p17t3', 'p17t4', 'p17t5'].includes(props.templateCode) && !validateFieldsP17()) {
            validToContinue = false;
        }
        if (['p18t1', 'p18t4'].includes(props.templateCode) && !validateFieldsP18()) {
            validToContinue = false;
        }
        if (['p18t2'].includes(props.templateCode) && !validateFieldsP18T2()) {
            validToContinue = false;
        }
        if (['p18t3'].includes(props.templateCode) && !validateFieldsP18T3()) {
            validToContinue = false;
        }
        if (['p19t1'].includes(props.templateCode) && !validateFieldsP19()) {
            validToContinue = false;
        }
        if (['p20t1', 'p20t2', 'p20t3', 'p20t4', 'p20t5', 'p20t6', 'p20t7', 'p20t8', 'p20t9'].includes(props.templateCode) && !validateFieldsP20()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p21t1' && !validateFieldsP21T1()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p21t2' && !validateFieldsP21T2()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p22t1' && !validateFieldsP22T1()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p22t2' && !validateFieldsP22T2()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p22t3' && !validateFieldsP22T3()) {
            validToContinue = false;
        }

        if (!validToContinue) {
            showNotification('Complete Information', 'Complete all the required fields to continue', 'info');
            return;
        }

        if (!['p1t10', 'p1t17', 'p1t18', 'p2t2', 'p2t4', 'p4t1', 'p4t3', 'p12t1', 'p12t2', 'p12t3', 'p12t4', 'p12t5', 'p12t6', 'p12t7', 'p12t8',
            'p12t9', 'p12t10', 'p17t1', 'p17t2', 'p17t3', 'p17t4', 'p17t5', 'p18t1', 'p18t4', 'p19t1'].includes(props.templateCode)) {
            props.setFrontDataUrl(getCanvasFrontDataUrl());
            props.setBackDataUrl(getCanvasBackDataUrl());
        }

        if (
            [
                'p1t8', 'p1t9', 'p1t11', 'p1t13', 'p1t14', 'p1t16', 'p1t15', 'p2t1', 'p2t3', 'p3t1', 'p3t2', 'p3t3', 'p3t4', 'p3t5', 'p3t6', 'p9t1',
                'p9t2', 'p9t3', 'p9t4', 'p9t5', 'p9t6', 'p9t7', 'p9t8', 'p9t9', 'p9t10', 'p9t11', 'p9t12', 'p9t13', 'p9t14', 'p9t15', 'p9t16', 'p9t17', 
                'p9t18', 'p9t19', 'p9t20', 'p9t21', 'p9t22', 'p9t23', 'p10t1', 'p10t2', 'p10t3', 'p10t4', 'p10t5', 'p10t6', 'p10t7', 'p10t8', 'p10t9', 'p10t10', 'p11t1', 
                'p11t2', 'p11t3', 'p11t4', 'p11t5', 'p11t6', 'p11t7', 'p11t8', 'p11t9', 'p11t10', 'p11t11', 'p11t12', 'p11t13', 'p11t14', 'p11t15', 
                'p11t16', 'p11t17', 'p11t18', 'p11t19', 'p11t20', 'p11t21', 'p11t22', 'p11t23', 'p11t24', 'p11t25', 'p20t1', 'p20t2', 'p20t3', 'p20t4', 
                'p20t5', 'p20t6', 'p20t7', 'p20t8', 'p20t9', 'p21t1', 'p21t2',
            ].includes(props.templateCode)
        ) {
            if (props.cxmlData.buyer_cookie == null) {
                props.setAddToCartOrderType(1);
                props.setAddToCartType(type);
                props.showConfirmationModal();
            } else {
                props.setAddToCartOrderType(2);
                props.setAddToCartType(type);
                props.showConfirmationModal();
            }
        } else {
            if (props.cxmlData.buyer_cookie == null) {
                props.addToCart(1, props.history, type);
            } else {
                props.addToCart(2, props.history, type);
            }
        }
    };

    const previewHandler = () => {
        let validToContinue = true;
        if (props.templateCode === 'p1t1' && !validateFieldsP1T1()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t2' && !validateFieldsP1T2()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t3' && !validateFieldsP1T3()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t4' && !validateFieldsP1T4()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t5' && !validateFieldsP1T5()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t6' && !validateFieldsP1T6()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t7' && !validateFieldsP1T7()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t8' && !validateFieldsP1T8()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t9' && !validateFieldsP1T9()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t10' && !validateFieldsP1T10()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t11' && !validateFieldsP1T11()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t12' && !validateFieldsP1T12()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t13' && !validateFieldsP1T13()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t14' && !validateFieldsP1T14()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t16' && !validateFieldsP1T16()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t17' && !validateFieldsP1T17()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t15' && !validateFieldsP1T15()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p1t18' && !validateFieldsP1T18()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p2t1' && !validateFieldsP2T1()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p2t3' && !validateFieldsP2T3()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p3t1' && !validateFieldsP3T1()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p3t2' && !validateFieldsP3T2()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p3t3' && !validateFieldsP3T3()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p3t4' && !validateFieldsP3T4()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p3t5' && !validateFieldsP3T5()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p3t6' && !validateFieldsP3T6()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p4t1' && !validateFieldsP4T1()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p4t3' && !validateFieldsP4T3()) {
            validToContinue = false;
        }
        if (['p9t1', 'p9t2', 'p9t3', 'p9t4', 'p9t5', 'p9t6', 'p9t7', 'p9t8'].includes(props.templateCode) && !validateFieldsP9()) {
            validToContinue = false;
        }
        if (['p9t9'].includes(props.templateCode) && !validateFieldsP9T9()) {
            validToContinue = false;
        }
        if (['p9t10'].includes(props.templateCode) && !validateFieldsP9T10()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p9t11' && !validateFieldsP9T11()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p9t12' && !validateFieldsP9T12()) {
            validToContinue = false;
        }
        if (['p9t13'].includes(props.templateCode) && !validateFieldsP9T13()) {
            validToContinue = false;
        }
        if (['p9t14'].includes(props.templateCode) && !validateFieldsP9T14()) {
            validToContinue = false;
        }
        if (['p9t15'].includes(props.templateCode) && !validateFieldsP9T15()) {
            validToContinue = false;
        }
        if (['p9t16'].includes(props.templateCode) && !validateFieldsP9T16()) {
            validToContinue = false;
        }
        if (['p9t17'].includes(props.templateCode) && !validateFieldsP9T17()) {
            validToContinue = false;
        }
        if (['p9t18'].includes(props.templateCode) && !validateFieldsP9T18()) {
            validToContinue = false;
        }
        if (['p9t19'].includes(props.templateCode) && !validateFieldsP9T19()) {
            validToContinue = false;
        }
        if (['p9t20'].includes(props.templateCode) && !validateFieldsP9T20()) {
            validToContinue = false;
        }
        if (['p9t21'].includes(props.templateCode) && !validateFieldsP9T21()) {
            validToContinue = false;
        }
        if (['p9t22'].includes(props.templateCode) && !validateFieldsP9T22()) {
            validToContinue = false;
        }
        if (['p9t23'].includes(props.templateCode) && !validateFieldsP9T23()) {
            validToContinue = false;
        }
        if (['p10t1', 'p10t2', 'p10t3', 'p10t4', 'p10t5', 'p10t6', 'p10t7'].includes(props.templateCode) && !validateFieldsP10()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p10t8' && !validateFieldsP10T8()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p10t9' && !validateFieldsP10T9()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p10t10' && !validateFieldsP10T10()) {
            validToContinue = false;
        }
        if (['p11t1', 'p11t2', 'p11t3', 'p11t4', 'p11t5', 'p11t6', 'p11t7', 'p11t8', 'p11t9', 'p11t10',
            'p11t11', 'p11t12', 'p11t13', 'p11t14', 'p11t15', 'p11t16', 'p11t17', 'p11t18', 'p11t19', 'p11t20',
            'p11t21', 'p11t22', 'p11t23', 'p11t25'].includes(props.templateCode) && !validateFieldsP11()) {
            validToContinue = false;
        }
        if (['p11t24'].includes(props.templateCode) && !validateFieldsP11T24()) {
            validToContinue = false;
        }
        if (['p12t1', 'p12t2', 'p12t3', 'p12t4', 'p12t5', 'p12t6', 'p12t7', 'p12t8', 'p12t9', 'p12t10'].includes(props.templateCode) && !validateFieldsP12()) {
            validToContinue = false;
        }
        if (['p18t2'].includes(props.templateCode) && !validateFieldsP18T2()) {
            validToContinue = false;
        }
        if (['p18t3'].includes(props.templateCode) && !validateFieldsP18T3()) {
            validToContinue = false;
        }
        if (['p20t1', 'p20t2', 'p20t3', 'p20t4', 'p20t5', 'p20t6', 'p20t7', 'p20t8', 'p20t9'].includes(props.templateCode) && !validateFieldsP20()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p21t1' && !validateFieldsP21T1()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p21t2' && !validateFieldsP21T2()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p22t1' && !validateFieldsP22T1()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p22t2' && !validateFieldsP22T2()) {
            validToContinue = false;
        }
        if (props.templateCode === 'p22t3' && !validateFieldsP22T3()) {
            validToContinue = false;
        }

        if (!validToContinue) {
            showNotification('Complete Information', 'Complete all the required fields to continue', 'info');
            return;
        }

        if (props.templateCode === 'p1t10') {
            window.open('https://ac-ut-health.s3.amazonaws.com/static/utp-billing-card-proof.pdf');
            return;
        } else if (props.templateCode === 'p1t17') {
            window.open('https://ac-ut-health.s3.amazonaws.com/variable-preview-images/billing-card-300924.png');
            return;
        } else if (props.templateCode === 'p4t1') {
            if (parseInt(props.color) === 1) {
                window.open('https://ac-ut-health.s3.amazonaws.com/static/utp-a6-foldover-notecard-white-proof.pdf');
            } else if (parseInt(props.color) === 2) {
                window.open('https://ac-ut-health.s3.amazonaws.com/static/utp-a6-foldover-notecard-orange-proof.pdf');
            } else if (parseInt(props.color) === 3) {
                window.open('https://ac-ut-health.s3.amazonaws.com/static/utp-a6-foldover-notecard-bw-proof.pdf');
            }
            return;
        } else if (props.templateCode === 'p4t3') {
            if (parseInt(props.color) === 1) {
                window.open('https://ac-ut-health.s3.amazonaws.com/variable-preview-images/p4t3-color.png');
            } else if (parseInt(props.color) === 2) {
                window.open('https://ac-ut-health.s3.amazonaws.com/variable-preview-images/p4t3-orange.png');
            } else if (parseInt(props.color) === 3) {
                window.open('https://ac-ut-health.s3.amazonaws.com/variable-preview-images/p4t3-black.png');
            }
            return;
        }

        let variables = [
            'templateCode=' + encodeURIComponent(props.templateCode),
            'name=' + encodeURIComponent(props.name),
            'credentials=' + encodeURIComponent(props.credentials),
            'title1=' + encodeURIComponent(props.title1),
            'title2=' + encodeURIComponent(props.title2),
            'title3=' + encodeURIComponent(props.title3),
            'department1=' + encodeURIComponent(props.department1),
            'department2=' + encodeURIComponent(props.department2),
            'department3=' + encodeURIComponent(props.department3),
            'phone=' + encodeURIComponent(props.phone),
            'clinic=' + encodeURIComponent(props.clinic),
            'fax=' + encodeURIComponent(props.fax),
            'pager=' + encodeURIComponent(props.pager),
            'nursePhone=' + encodeURIComponent(props.nursePhone),
            'fontType=' + encodeURIComponent(props.fontType),
            'address=' + encodeURIComponent(props.address),
            'city=' + encodeURIComponent(props.city),
            'state=' + encodeURIComponent(props.state),
            'zip=' + encodeURIComponent(props.zip),
            'email=' + encodeURIComponent(props.email),
            'showEmail=' + encodeURIComponent(props.showEmail),
            'open1=' + encodeURIComponent(props.open1),
            'open2=' + encodeURIComponent(props.open2),
            'open3=' + encodeURIComponent(props.open3),
            'nameDivided=' + encodeURIComponent(getCanvasValues().nameDivided),
            'name1=' + encodeURIComponent(getCanvasValues().name1),
            'name2=' + encodeURIComponent(getCanvasValues().name2),
            'cell=' + encodeURIComponent(props.cell),
            'showCell=' + encodeURIComponent(props.showCell),
            'address2=' + encodeURIComponent(props.address2),
            'address3=' + encodeURIComponent(props.address3),
            'color=' + encodeURIComponent(props.color),
            'stock=' + encodeURIComponent(props.stock),
            'frontDividers=' + JSON.stringify(getCanvasValues().frontDividers),
            'backDividers=' + JSON.stringify(getCanvasValues().backDividers),
            'contact1Phone=' + encodeURIComponent(props.contact1Phone),
            'contact1Type=' + encodeURIComponent(props.contact1Type),
            'contact2Phone=' + encodeURIComponent(props.contact2Phone),
            'contact2Type=' + encodeURIComponent(props.contact2Type),
            'locations=' + encodeURIComponent(props.locations),
            'front=' + encodeURIComponent(props.front),
            'back=' + encodeURIComponent(props.back),
            'suiteRoom=' + encodeURIComponent(props.suiteRoom),
            'firstName=' + encodeURIComponent(props.firstName),
            'middleName=' + encodeURIComponent(props.middleName),
            'lastName=' + encodeURIComponent(props.lastName),
            'primaryTitle=' + encodeURIComponent(props.primaryTitle),
            'secondaryTitle=' + encodeURIComponent(props.secondaryTitle),
            'title4=' + encodeURIComponent(props.title4),
            'main=' + encodeURIComponent(props.main),
            'direct=' + encodeURIComponent(props.direct),
            'website=' + encodeURIComponent(props.website),
            'schedulingCard=' + encodeURIComponent(props.schedulingCard),
            'addressSize=' + encodeURIComponent(getCanvasValues().addressSize),
            'nameSize=' + encodeURIComponent(getCanvasValues().nameSize),
            'titlesSize=' + encodeURIComponent(getCanvasValues().titlesSize),
            'yStep=' + encodeURIComponent(getCanvasValues().yStep),
            'sectionStep=' + encodeURIComponent(getCanvasValues().sectionStep),
            'phoneLabelSize=' + encodeURIComponent(getCanvasValues().phoneLabelSize),
            'phoneLabelX=' + encodeURIComponent(getCanvasValues().phoneLabelX),
            'phoneLabelY=' + encodeURIComponent(getCanvasValues().phoneLabelY),
            'phoneLabelSize=' + encodeURIComponent(getCanvasValues().phoneLabelSize),
            'addEnvelopes=' + JSON.stringify(props.addEnvelopes),
            'letterheadPersons=' + JSON.stringify(props.letterheadPersons),
            'prescriptionPadDoctors=' + JSON.stringify(props.prescriptionPadDoctors),
            'window=' + encodeURIComponent(props.window),
            'showSocialMediaIcons=' + encodeURIComponent(props.showSocialMediaIcons),
            'additionalField=' + encodeURIComponent(props.additionalField),
            'phoneLabel1=' + encodeURIComponent(props.phoneLabel1),
            'phoneLabel2=' + encodeURIComponent(props.phoneLabel2),
            'phoneLabel3=' + encodeURIComponent(props.phoneLabel3),
            'phoneOtherLabel1=' + encodeURIComponent(props.phoneOtherLabel1),
            'phoneOtherLabel2=' + encodeURIComponent(props.phoneOtherLabel2),
            'phoneOtherLabel3=' + encodeURIComponent(props.phoneOtherLabel3),
            'language=' + encodeURIComponent(props.language),
            'clinicId=' + encodeURIComponent(props.clinicId),
        ];

        let locations = 0;
        if (props.templateCode === 'p1t5') {
            locations = 3;
        } else if (props.templateCode === 'p1t6') {
            locations = 2;
        } else if (props.templateCode === 'p1t9') {
            locations = props.locations;
        } else if (props.templateCode === 'p1t13') {
            locations = props.locations;
        } else if (props.templateCode === 'p1t16') {
            locations = props.locations;
        }

        for (let i = 0; i < locations; i++) {
            if (!isEmpty(props.locationNames[i])) {
                variables.push('locationName' + (i + 1) + '=' + encodeURIComponent(props.locationNames[i]));
            }
            if (!isEmpty(props.locationPhones[i])) {
                variables.push('locationPhone' + (i + 1) + '=' + encodeURIComponent(props.locationPhones[i]));
            }
            if (!isEmpty(props.locationFaxes[i])) {
                variables.push('locationFax' + (i + 1) + '=' + encodeURIComponent(props.locationFaxes[i]));
            }
            if (!isEmpty(props.locationNursePhones[i])) {
                variables.push('locationNursePhone' + (i + 1) + '=' + encodeURIComponent(props.locationNursePhones[i]));
            }
            if (!isEmpty(props.locationAddresses1[i])) {
                variables.push('locationAddress1' + (i + 1) + '=' + encodeURIComponent(props.locationAddresses1[i]));
            }
            if (!isEmpty(props.locationAddresses2[i])) {
                variables.push('locationAddress2' + (i + 1) + '=' + encodeURIComponent(props.locationAddresses2[i]));
            }
            if (!isEmpty(props.locationAddresses3[i])) {
                variables.push('locationAddress3' + (i + 1) + '=' + encodeURIComponent(props.locationAddresses3[i]));
            }
            if (!isEmpty(props.locationCities[i])) {
                variables.push('locationCity' + (i + 1) + '=' + encodeURIComponent(props.locationCities[i]));
            }
            if (!isEmpty(props.locationStates[i])) {
                variables.push('locationState' + (i + 1) + '=' + encodeURIComponent(props.locationStates[i]));
            }
            if (!isEmpty(props.locationZips[i])) {
                variables.push('locationZip' + (i + 1) + '=' + encodeURIComponent(props.locationZips[i]));
            }
            if (!isEmpty(props.locationSuites[i])) {
                variables.push('locationSuite' + (i + 1) + '=' + encodeURIComponent(props.locationSuites[i]));
            }
        }

        if (['p10t1', 'p10t2', 'p10t3', 'p10t4', 'p10t5', 'p10t6', 'p10t7', 'p10t8', 'p10t9', 'p10t10'].includes(props.templateCode)) {
            for (let i = 0; i < props.titles.length; i++) {
                variables.push('titles' + (i + 1) + '=' + encodeURIComponent(props.titles[i]));
            }
            for (let i = 0; i < props.personsNames.length; i++) {
                if (!isEmpty(props.personsNames[i])) {
                    variables.push('personsNames' + (i + 1) + '=' + encodeURIComponent(props.personsNames[i]));
                }
            }
            for (let i = 0; i < props.personsTitles.length; i++) {
                if (!isEmpty(props.personsTitles[i])) {
                    variables.push('personsTitles' + (i + 1) + '=' + encodeURIComponent(props.personsTitles[i]));
                }
            }
        }

        window.open(process.env.REACT_APP_API_URL + '/uthealth-order/preview?' + variables.join('&'));
    };

    const renderForm = () => {
        if (props.templateCode === 'p1t1') {
            return (
                <FormP1T1 {...props} />
            );
        } else if (props.templateCode === 'p1t2') {
            return (
                <FormP1T2 {...props} />
            );
        } else if (props.templateCode === 'p1t3') {
            return (
                <FormP1T3 {...props} />
            );
        } else if (props.templateCode === 'p1t4') {
            return (
                <FormP1T4 {...props} />
            );
        } else if (props.templateCode === 'p1t5') {
            return (
                <FormP1T5 {...props} />
            );
        } else if (props.templateCode === 'p1t6') {
            return (
                <FormP1T6 {...props} />
            );
        } else if (props.templateCode === 'p1t7') {
            return (
                <FormP1T7 {...props} />
            );
        } else if (props.templateCode === 'p1t8') {
            return (
                <FormP1T8 {...props} />
            );
        } else if (props.templateCode === 'p1t9') {
            return (
                <FormP1T9 {...props} />
            );
        } else if (props.templateCode === 'p1t10') {
            return (
                <FormP1T10 {...props} />
            );
        } else if (props.templateCode === 'p1t11') {
            return (
                <FormP1T11 {...props} />
            );
        } else if (props.templateCode === 'p1t12') {
            return (
                <FormP1T12 {...props} />
            );
        } else if (props.templateCode === 'p1t13') {
            return (
                <FormP1T13 {...props} />
            );
        } else if (props.templateCode === 'p1t14') {
            return (
                <FormP1T14 {...props} />
            );
        } else if (props.templateCode === 'p1t15') {
            return (
                <FormP1T15 {...props} />
            );
        } else if (props.templateCode === 'p1t16') {
            return (
                <FormP1T16 {...props} />
            );
        } else if (props.templateCode === 'p1t17') {
            return (
                <FormP1T17 {...props} />
            );
        } else if (props.templateCode === 'p1t18') {
            return (
                <FormP1T18 {...props} />
            );
        } else if (props.templateCode === 'p2t1') {
            return (
                <FormP2T1 {...props} />
            );
        } else if (props.templateCode === 'p2t2') {
            return (
                <FormP2T2 {...props} />
            );
        } else if (props.templateCode === 'p2t3') {
            return (
                <FormP2T3 {...props} />
            );
        } else if (props.templateCode === 'p2t4') {
            return (
                <FormP2T4 {...props} />
            );
        } else if (props.templateCode === 'p3t1') {
            return (
                <FormP3T1 {...props} />
            );
        } else if (props.templateCode === 'p3t2') {
            return (
                <FormP3T2 {...props} />
            );
        } else if (props.templateCode === 'p3t3') {
            return (
                <FormP3T3 {...props} />
            );
        } else if (props.templateCode === 'p3t4') {
            return (
                <FormP3T4 {...props} />
            );
        } else if (props.templateCode === 'p3t5') {
            return (
                <FormP3T5 {...props} />
            );
        } else if (props.templateCode === 'p3t6') {
            return (
                <FormP3T6 {...props} />
            );
        } else if (props.templateCode === 'p4t1') {
            return (
                <FormP4T1 {...props} />
            );
        } else if (props.templateCode === 'p4t3') {
            return (
                <FormP4T3 {...props} />
            );
        } else if (['p9t1', 'p9t2', 'p9t3', 'p9t4', 'p9t5', 'p9t6', 'p9t7', 'p9t8', 'p9t9', 'p9t10'].includes(props.templateCode)) {
            return (
                <FormP9 {...props} />
            );
        } else if (props.templateCode === 'p9t11') {
            return (
                <FormP9T11 {...props} />
            );
        } else if (props.templateCode === 'p9t12') {
            return (
                <FormP9T12 {...props} />
            );
        } else if (props.templateCode === 'p9t13') {
            return (
                <FormP9T13 {...props} />
            );
        } else if (props.templateCode === 'p9t14') {
            return (
                <FormP9T14 {...props} />
            );
        } else if (props.templateCode === 'p9t15') {
            return (
                <FormP9T15 {...props} />
            );
        } else if (props.templateCode === 'p9t16') {
            return (
                <FormP9T16 {...props} />
            );
        } else if (props.templateCode === 'p9t17') {
            return (
                <FormP9T17 {...props} />
            );
        } else if (props.templateCode === 'p9t18') {
            return (
                <FormP9T18 {...props} />
            );
        } else if (props.templateCode === 'p9t19') {
            return (
                <FormP9T19 {...props} />
            );
        } else if (props.templateCode === 'p9t20') {
            return (
                <FormP9T20 {...props} />
            );
        } else if (props.templateCode === 'p9t21') {
            return (
                <FormP9T21 {...props} />
            );
        } else if (props.templateCode === 'p9t22') {
            return (
                <FormP9T22 {...props} />
            );
        } else if (props.templateCode === 'p9t23') {
            return (
                <FormP9T23 {...props} />
            );
        } else if (['p10t1', 'p10t2', 'p10t3', 'p10t4', 'p10t5', 'p10t6', 'p10t7'].includes(props.templateCode)) {
            return (
                <FormP10 {...props} />
            );
        } else if (props.templateCode === 'p10t8') {
            return (
                <FormP10T8 {...props} />
            );
        } else if (props.templateCode === 'p10t9') {
            return (
                <FormP10T9 {...props} />
            );
        } else if (props.templateCode === 'p10t10') {
            return (
                <FormP10T10 {...props} />
            );
        } else if (['p11t1', 'p11t2', 'p11t3', 'p11t4', 'p11t5', 'p11t6', 'p11t7', 'p11t8', 'p11t9',
            'p11t10', 'p11t11', 'p11t12', 'p11t13', 'p11t14', 'p11t15', 'p11t16', 'p11t17', 'p11t18',
            'p11t19', 'p11t20', 'p11t21'].includes(props.templateCode)) {
            return (
                <FormP11 {...props} />
            );
        } else if (props.templateCode === 'p11t22') {
            return (
                <FormP11T22 {...props} />
            );
        } else if (props.templateCode === 'p11t23') {
            return (
                <FormP11T23 {...props} />
            );
        } else if (props.templateCode === 'p11t24') {
            return (
                <FormP11T24 {...props} />
            );
        } else if (props.templateCode === 'p11t25') {
            return (
                <FormP11T25 {...props} />
            );
        } else if (['p12t1', 'p12t2', 'p12t3', 'p12t4', 'p12t5', 'p12t6', 'p12t7', 'p12t8', 'p12t9', 'p12t10'].includes(props.templateCode)) {
            return (
                <FormP12 {...props} />
            );
        } else if (props.templateCode === 'p17t1') {
            return (
                <FormP17T1 {...props} />
            );
        } else if (props.templateCode === 'p17t2') {
            return (
                <FormP17T2 {...props} />
            );
        } else if (props.templateCode === 'p17t3') {
            return (
                <FormP17T3 {...props} />
            );
        } else if (props.templateCode === 'p17t4') {
            return (
                <FormP17T4 {...props} />
            );
        } else if (props.templateCode === 'p17t5') {
            return (
                <FormP17T5 {...props} />
            );
        } else if (props.templateCode === 'p18t1') {
            return (
                <FormP18T1 {...props} />
            );
        } else if (props.templateCode === 'p18t2') {
            return (
                <FormP18T2 {...props} />
            );
        } else if (props.templateCode === 'p18t3') {
            return (
                <FormP18T3 {...props} />
            );
        } else if (props.templateCode === 'p18t4') {
            return (
                <FormP18T4 {...props} />
            );
        } else if (props.templateCode === 'p19t1') {
            return (
                <FormP19T1 {...props} />
            );
        } else if (['p20t1', 'p20t2', 'p20t3', 'p20t4', 'p20t5', 'p20t6'].includes(props.templateCode)) {
            return (
                <FormP20 {...props} />
            );
        } else if (props.templateCode === 'p20t7') {
            return (
                <FormP20T7 {...props} />
            );
        } else if (props.templateCode === 'p20t8') {
            return (
                <FormP20T8 {...props} />
            );
        } else if (props.templateCode === 'p20t9') {
            return (
                <FormP20T9 {...props} />
            );
        } else if (props.templateCode === 'p21t1') {
            return (
                <FormP21T1 {...props} />
            );
        } else if (props.templateCode === 'p21t2') {
            return (
                <FormP21T2 {...props} />
            );
        } else if (props.templateCode === 'p22t1') {
            return (
                <FormP22T1 {...props} />
            );
        } else if (props.templateCode === 'p22t2') {
            return (
                <FormP22T2 {...props} />
            );
        } else if (props.templateCode === 'p22t3') {
            return (
                <FormP22T3 {...props} />
            );
        }

        return null;
    };

    let buttonLabel = 'Checkout';
    if (props.addingToCart) {
        buttonLabel = <Fragment><i className="fas fa-circle-notch fa-spin" /> Adding to Cart...</Fragment>;
    }

    let saveWorkLabel = 'Save Work';
    if (props.savingWork) {
        saveWorkLabel = <Fragment><i className="fas fa-circle-notch fa-spin" /> Saving...</Fragment>;
    }

    let previewButton = <div><button type="button" className="preview" onClick={previewHandler}>Preview</button></div>;
    if (['p2t2', 'p2t4', 'p12t1', 'p12t2', 'p12t3', 'p12t4', 'p12t5', 'p12t6', 'p12t7', 'p12t8', 'p12t9', 'p12t10', 'p1t12', 'p22t1', 'p22t2', 'p22t3'].includes(props.templateCode)) {
        previewButton = null;
    }

    let title = 'Variables';
    if (['p1t18', 'p17t1', 'p17t2', 'p17t3', 'p17t4', 'p17t5', 'p18t1', 'p18t4', 'p19t1'].includes(props.templateCode)) {
        title = 'Please make your selections below';
        previewButton = null;
    }

    let favoriteClasses = ['favorite-container'];
    let favoriteIcon = <i className="far fa-heart empty-heart" />;
    if (props.isFavorite) {
        favoriteClasses.push('active');
        favoriteIcon = <i className="fas fa-heart filled-heart" />
    }

    const handleAddFavorite = () => {
        props.addFavorite(props.history);
    };

    let shoppingCartButton = <div><button type="button" className="continue" onClick={continueHandler.bind(this, 1)} disabled={props.addingToCart}>{buttonLabel}</button></div>;
    if (props.action === 'edit') {
        shoppingCartButton = null;
    }

    return (
        <div className="form-container">
            <h5>{title}</h5>
            <div className={favoriteClasses.join(' ')} onClick={handleAddFavorite}>
                {favoriteIcon} Favorites
            </div>
            {renderForm()}
            <div className="text-center">
                {previewButton}
                <div><button type="button" className="continue" onClick={continueHandler.bind(this, 2)} disabled={props.savingWork}>{saveWorkLabel}</button></div>
                {shoppingCartButton}
            </div>
        </div>
    );
});

export default Form;
